<template>
  <div class="empty-pane">
    <!-- 閉じるリンク -->
    <div class="empty-pane__close-area">
      <span
        class="back-link"
        role="button"
        tabindex="0"
        @click="emit('close')"
        @keydown.enter="emit('close')"
        @keydown.space="emit('close')"
      >
        × 閉じる
      </span>
    </div>

    <div class="empty-pane__body">
      <div class="empty-pane__icon">
        <img
          src="~green/icon/icon_doctor_simple.svg"
          alt=""
          class="empty-pane__icon-image"
        />
      </div>
      <h2 class="empty-pane__title">
        条件に一致する相談が<br />見つかりませんでした
      </h2>
      <div class="empty-pane__message">
        <p>
          事例が見つからない場合、あなた特有の症状かもしれません。<br />
          医師へ直接相談しませんか？
        </p>
      </div>
      <a
        :href="consultUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="button button--primary button--lg button--full empty-pane__consult"
      >
        <b>ネットで医師相談</b>
        <span class="material-icons" aria-hidden="true">chevron_right</span>
      </a>
      <button
        type="button"
        class="empty-pane__retry-link"
        @click="emit('retry')"
      >
        条件を変えて検索しなおす
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
const consultUrl = '/topics/add-form';

const emit = defineEmits<{
  close: [];
  retry: [];
}>();
</script>

<style lang="scss" scoped>
@import '~green/_variables.scss';

.empty-pane {
  display: flex;
  flex-direction: column;
  padding: 16px;

  &__close-area {
    padding: 8px 16px 0;
  }

  &__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 32px 16px;
  }

  &__icon {
    width: 80px;
    height: 80px;
    margin-bottom: 16px;
  }

  &__icon-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &__title {
    font-size: 1.25rem;
    font-weight: bold;
    color: $base-font-color;
    margin: 0 0 24px;
    line-height: 1.5;
  }

  &__message {
    background-color: $section-background-color;
    border-radius: $border-radius-base;
    padding: 16px;
    margin-bottom: 24px;
    width: 100%;

    p {
      margin: 0;
      font-size: 0.875rem;
      line-height: 1.6;
      color: $base-font-color;
    }
  }

  &__consult {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 16px;
  }

  &__retry-link {
    background: none;
    border: none;
    color: $primary-color;
    font-size: 0.875rem;
    text-decoration: underline;
    cursor: pointer;
    padding: 8px;

    &:hover {
      text-decoration: none;
    }
  }
}

.back-link {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  width: fit-content;
  padding: 8px 0;
  font-size: 0.875rem;
  color: $tertiary-color;
  cursor: pointer;
  user-select: none;
  transition: color 0.2s ease;

  &:hover,
  &:focus {
    color: $primary-color;
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid $primary-color;
    outline-offset: 2px;
    border-radius: 4px;
  }
}
</style>
